import { bulkUpdateUsers, bulkDeleteUsers, bulkReinviteUsers } from '@/shared/api/bulk';

/**
 * Actions de masse des comptes, au format `shared/components/BulkEditDialog`.
 *
 * « Réinviter » envoie de vrais e-mails et « Supprimer » est définitif : ces deux-là se
 * confirmaient jusqu'ici dans une alerte du navigateur, au même titre qu'un changement
 * de rôle. Elles portent maintenant leur propre avertissement.
 */
const USER_BULK_ACTIONS = {
  role: {
    label: 'Changer le rôle',
    family: 'select',
    value_label: 'Nouveau rôle',
    value_placeholder: 'Choisir un rôle',
    options: [
      { value: 'admin', label: 'Administrateur' },
      { value: 'commercial', label: 'Gestionnaire' },
      { value: 'installateur', label: 'Installateur' },
    ],
    warning: "Le rôle définit ce que chaque compte peut voir et faire. Un passage en "
      + 'administrateur donne accès au pilotage du parc.',
    run: (ids, role) => bulkUpdateUsers(ids, role),
  },
  reinvite: {
    label: "Renvoyer l'invitation",
    family: 'action',
    alwaysReport: true,
    warning: "Un e-mail « définissez votre mot de passe » part réellement vers chaque "
      + "adresse sélectionnée. Les invitations précédentes sont invalidées.",
    run: ids => bulkReinviteUsers(ids),
  },
  delete: {
    label: 'Supprimer les comptes',
    family: 'action',
    tone: 'danger',
    alwaysReport: true,
    warning: "Suppression définitive : les personnes concernées perdent immédiatement "
      + "l'accès à l'application, sans restauration possible depuis l'interface.",
    run: ids => bulkDeleteUsers(ids),
  },
};

export default USER_BULK_ACTIONS;
